// extracted by mini-css-extract-plugin
export default {"form_send_button":"FormSendButton-module__form_send_button--ID6F7"};